// import React, { useEffect, useRef } from 'react';
// import gsap from 'gsap';

// function IntroAnimation({ onComplete, children, overlapOffset = 100 }) {
//   const introRef = useRef(null);
//   const titleRef = useRef(null);
//   const circleRef = useRef(null);
//   const bgImageRef = useRef(null);
//   const wrapperRef = useRef(null);
//   const mainDivRef = useRef(null);

//   useEffect(() => {
//     document.body.style.overflow = 'hidden';
//     gsap.set(wrapperRef.current, { y: 0 });
//     gsap.set(circleRef.current, { y: 0 });

//     const tl = gsap.timeline({
//       onComplete: () => {
//         document.body.style.overflow = '';
//       }
//     });

//     tl.fromTo(
//       titleRef.current,
//       { opacity: 0, y: 40 },
//       { opacity: 1, y: 0, duration: 0.4, ease: "power3.out" }
//     )
//     .fromTo(
//       bgImageRef.current,
//       { opacity: 0 },
//       { opacity: 1, duration: 0.2, ease: "power2.inOut" }
//     )
//     .fromTo(
//       circleRef.current,
//       { opacity: 0, y: 15 },
//       { opacity: 1, y: 0, duration: 0.1, ease: "power3.out" },
//       "<"
//     )
//     .fromTo(
//       mainDivRef.current,
//       { opacity: 0, y: 30 },
//       { opacity: 1, y: 0, duration: 0.5, ease: "power3.out" },
//       "<"
//     );

//     let hasScrolled = false;

//     const handleWheel = () => {
//       if (hasScrolled) return;
//       hasScrolled = true;

//       gsap.to(wrapperRef.current, {
//         y: -750,
//         duration: 2,
//         ease: "power2.inOut",
//         onComplete: () => {
//           document.body.style.overflow = 'auto';
//         }
//       });
//     };

//     window.addEventListener("wheel", handleWheel, { passive: true });

//     return () => {
//       window.removeEventListener("wheel", handleWheel);
//     };
//   }, []);

//   return (
//     <>
//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//       `}</style>

//       <div ref={introRef} style={{
//         position: "fixed",
//         top: 0, left: 0,
//         width: "100%", height: "100%",
//         background: "#0A0A0A",
//         zIndex: 50,  // ← נמוך מה-Navbar של Layout
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         paddingBottom: "300px"
//       }}>

//         {/* רקע */}
//         <div ref={bgImageRef} style={{
//           position: "absolute",
//           top: 0, left: 0,
//           width: "100%", height: "100%",
//           backgroundImage: "url('/image/gpt.png')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           opacity: 0,
//           zIndex: 0
//         }} />

//         {/* כותרת */}
//         <div ref={titleRef} style={{
//           textAlign: "center",
//           marginBottom: "40px",
//           position: "relative",
//           zIndex: 1
//         }}>
//           <h1 style={{ fontSize: "56px", fontWeight: "400", color: "rgba(255,255,255,0.9)", margin: 0, lineHeight: 1.2 }}>
//             Intelligent Security
//           </h1>
//           <h2 style={{ fontSize: "56px", fontWeight: "400", color: "rgba(255,255,255,0.9)", margin: 0, lineHeight: 1.2 }}>
//             Powered by AI.
//           </h2>
//         </div>

//         {/* wrapper - עיגול + div */}
//         <div ref={wrapperRef} style={{
//           position: "absolute",
//           top: "20%",
//           width: "100%",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           zIndex: 2
//         }}>

//           {/* עיגול */}
//           <div ref={circleRef} style={{
//             opacity: 0,
//             width: "100%",
//             display: "flex",
//             justifyContent: "center",
//           }}>
//             <img
//               src="/image/circle.png"
//               alt="circle"
//               style={{
//                 width: "90vw",
//                 maxWidth: "none",
//                 height: "auto",
//                 display: "block",
//                 animation: "spin 8s linear infinite"
//               }}
//             />
//           </div>

//           {/* div - מתחת לעיגול */}
//           <div ref={mainDivRef} style={{
//             width: "90%",
//             opacity: 0,
//             marginTop: `-${overlapOffset}px`,
//             position: "relative",
//             zIndex: 10
//           }}>
//             {children}
//           </div>

//         </div>

//       </div>
//     </>
//   );
// }

// export default IntroAnimation;
import React from 'react';

function IntroAnimation({ children }) {
  return children;
}

export default IntroAnimation;